import { render, staticRenderFns } from "./DigitalHeaderServiceForm.vue?vue&type=template&id=81dde0d4&"
import script from "./DigitalHeaderServiceForm.vue?vue&type=script&lang=js&"
export * from "./DigitalHeaderServiceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports